<div class="committee-container">
  <!-- Header card -->
  <div class="committee-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-gavel"></i>
        <div class="header-text">
          <h1>Comité de Aprobaciones</h1>
          <p class="header-subtitle">Lo que el comité decidió sobre este arrendamiento, sesión por sesión.</p>
        </div>
      </div>
      <div class="header-right">
        <p-tag *ngIf="committee" [value]="overallLabel()" [severity]="overallSeverity()"></p-tag>
        <!--
          UN solo botón (F-143). Las sesiones se crean en /comites: aquí se llega con este
          arrendamiento ya puesto (`?llevar=`). Sustituye a «Iniciar reunión» y a «Registrar comité»:
          la sesión crea el comité si no existe y lo documenta si ya decidió.
        -->
        <button
          *ngIf="canBringToCommittee"
          pButton
          type="button"
          label="Llevar a comité"
          icon="fa-solid fa-gavel"
          class="p-button-success p-button-sm act-bring"
          pTooltip="Abre una sesión del comité con este arrendamiento"
          tooltipPosition="bottom"
          (click)="goToCommittees()"
        ></button>
      </div>
    </div>
  </div>

  <!--
    Presentación a Comité (F-165). Es del arrendamiento: va fuera de los bloques de comité y de reuniones porque se sube
    aunque no haya comité ni sesiones. Ver y descargar, todo el que ve la pestaña; subir y quitar, con upload-presentation.
  -->
  <div class="info-card wide-card presentation-card">
    <div class="card-header">
      <i class="fa-solid fa-person-chalkboard text-blue-600"></i>
      <h3>Presentación a Comité</h3>
    </div>
    <div class="card-content actas-block presentation-block">
      <p class="actas-saving" *ngIf="presentationsLoading"><i class="pi pi-spin pi-spinner"></i> Cargando la presentación…</p>
      <div class="actas-empty" *ngIf="!presentationsLoading && presentationsError">
        <i class="pi pi-exclamation-circle"></i>
        <p>No se pudo cargar la Presentación a Comité.</p>
        <button pButton type="button" label="Reintentar" class="p-button-text p-button-sm" (click)="loadPresentations()"></button>
      </div>
      <ng-container *ngIf="!presentationsLoading && !presentationsError">
        <div class="actas-list" *ngIf="presentations.length; else sinPresentacion">
          <div class="acta-row presentation-row" *ngFor="let p of presentations">
            <i class="fa-regular fa-file-pdf acta-icon"></i>
            <div class="acta-text">
              <span class="acta-name">{{ p.name }}</span>
              <span class="acta-meta"
                ><ng-container *ngIf="p.uploadedByName">{{ p.uploadedByName }} · </ng-container>{{ formatDate(p.uploadedAt) }}</span
              >
            </div>
            <button
              pButton
              type="button"
              icon="fa-solid fa-eye"
              class="p-button-text p-button-sm presentation-preview"
              pTooltip="Previsualizar"
              tooltipPosition="top"
              [attr.aria-label]="'Previsualizar ' + p.name"
              (click)="previewPresentation(p)"
            ></button>
            <button
              pButton
              type="button"
              icon="fa-solid fa-download"
              class="p-button-text p-button-sm presentation-download"
              pTooltip="Descargar"
              tooltipPosition="top"
              [attr.aria-label]="'Descargar ' + p.name"
              (click)="downloadPresentation(p)"
            ></button>
            <button
              *ngIf="canUploadPresentation"
              pButton
              type="button"
              icon="fa-solid fa-trash"
              class="p-button-text p-button-sm p-button-danger presentation-remove"
              pTooltip="Quitar"
              tooltipPosition="top"
              [attr.aria-label]="'Quitar ' + p.name"
              [disabled]="presentationBusy"
              (click)="confirmRemovePresentation(p)"
            ></button>
          </div>
        </div>
        <ng-template #sinPresentacion>
          <div class="actas-empty">
            <i class="fa-regular fa-file-lines"></i>
            <p>Este arrendamiento aún no tiene Presentación a Comité.</p>
            <small *ngIf="canUploadPresentation">Sube el PDF que el comité va a revisar; no hace falta que haya una sesión.</small>
          </div>
        </ng-template>
        <!--
          Se destruye y se vuelve a crear al registrar, igual que el de actas: `app-input-single-file` solo limpia su estado
          cuando cambia `fileUrlValue`. El prefijo del blob es el id del arrendamiento, no un RFC: ningún externo lo lee.
        -->
        <div class="presentation-upload" *ngIf="canUploadPresentation">
          <app-input-single-file
            *ngIf="!presentationBusy; else registrandoPresentacion"
            label="Agregar presentación"
            [folder]="'committee'"
            [documentName]="'presentacion-comite'"
            [id]="leaseDetailService.id || ''"
            [fileUrlValue]="null"
            [tooltip]="'Archivo PDF con la Presentación a Comité'"
            (fileUrl)="onPresentationSelected($event)"
          ></app-input-single-file>
          <ng-template #registrandoPresentacion>
            <p class="actas-saving"><i class="pi pi-spin pi-spinner"></i> Registrando la presentación…</p>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>

  <!--
    Sin comité. Es el caso de toda la cartera heredada: la migración nunca creó el `Committee`. La
    sesión (F-143) lo crea al llevar el arrendamiento; aquí solo se dice.
  -->
  <div *ngIf="!committee" class="info-card">
    <div class="card-content empty-state">
      <i class="pi pi-info-circle"></i>
      <p>Este arrendamiento no tiene comité registrado.</p>
      <small *ngIf="canManage"
        >Es lo normal en los contratos antiguos. Llévalo a una sesión del comité —o registra su acta histórica— con «Llevar a
        comité».</small
      >
      <small *ngIf="!canManage">Es lo normal en los contratos antiguos. Legal lo lleva a una sesión del comité cuando corresponda.</small>
    </div>
  </div>

  <ng-container *ngIf="committee">
    <!-- El comité ya decidió: lo que se registre de aquí en adelante documenta, no re-decide -->
    <div class="documenta-banner" *ngIf="isTerminal">
      <i class="pi pi-info-circle"></i>
      <div>
        <strong>Este comité ya emitió su decisión ({{ overallLabel() }}).</strong>
        <span>Puedes llevarlo a sesiones posteriores y adjuntar sus actas. No cambian la decisión ni el estado del arrendamiento.</span>
      </div>
    </div>
    <!-- Reunión en curso -->
    <div *ngIf="openMeeting as m" class="info-card wide-card">
      <div class="card-header">
        <i class="fa-solid fa-people-group text-blue-600"></i>
        <h3>Reunión en curso</h3>
        <div class="header-tags">
          <span class="meeting-date"><i class="pi pi-calendar"></i> {{ formatDate(m.meetingDate) }}</span>
          <p-tag value="Abierta" severity="info"></p-tag>
        </div>
      </div>
      <div class="card-content">
        <!-- La sesión a la que pertenece: ahí se cierra, se editan votantes y se sube el acta -->
        <ng-container *ngTemplateOutlet="sessionBlock; context: { $implicit: m }"></ng-container>

        <!-- Quórum + tally + resultado proyectado -->
        <div class="quorum-row">
          <div class="quorum-box">
            <span class="q-label">Quórum</span>
            <span class="q-value" [class.met]="quorum(m).met">{{ quorum(m).voted }}/{{ quorum(m).selected }}</span>
            <span class="q-hint">mínimo {{ quorum(m).min }}</span>
          </div>
          <div class="tally">
            <span class="t aprob"><i class="pi pi-thumbs-up"></i> {{ tally(m).aprobados }}</span>
            <span class="t rech"><i class="pi pi-thumbs-down"></i> {{ tally(m).rechazados }}</span>
            <span class="t pend"><i class="pi pi-clock"></i> {{ tally(m).pendientes }}</span>
          </div>
          <div class="projected">
            <span class="p-label">Resultado proyectado</span>
            <p-tag [value]="resultLabel(projectedResult(m))" [severity]="resultSeverity(projectedResult(m))"></p-tag>
          </div>
        </div>

        <!-- Votantes -->
        <div class="voters-list">
          <div class="voter-row" *ngFor="let vid of m.selectedVoters">
            <div class="voter-main">
              <div class="voter-id">
                <span class="avatar">{{ memberInitials(vid) }}</span>
                <div class="voter-text">
                  <span class="voter-name">{{ memberName(vid) }}<span class="you" *ngIf="vid === currentUserId"> (tú)</span></span>
                  <span class="voter-email">{{ memberEmail(vid) }}</span>
                </div>
              </div>
              <div class="voter-vote">
                <p-tag
                  *ngIf="voteOf(m, vid) as vt; else pendingVote"
                  [value]="vt.decision"
                  [severity]="decisionSeverity(vt.decision)"
                  [icon]="vt.decision === 'Aprobado' ? 'pi pi-check' : 'pi pi-times'"
                ></p-tag>
                <ng-template #pendingVote>
                  <p-tag value="Pendiente" severity="warning" icon="pi pi-clock"></p-tag>
                </ng-template>
              </div>
            </div>
            <div class="voter-comment" *ngIf="voteOf(m, vid)?.memberComments as cmt">
              <i class="pi pi-comment"></i>
              <p>{{ cmt }}</p>
            </div>
          </div>
        </div>

        <!-- Actas de la reunión en curso -->
        <ng-container *ngTemplateOutlet="actasBlock; context: { $implicit: m }"></ng-container>

        <!-- Acciones. Votar SIEMPRE (D-4); cerrar y editar votantes solo en una reunión sin sesión (D-5). -->
        <div class="meeting-actions">
          <button
            *ngIf="canCastVote"
            pButton
            type="button"
            [label]="myVote(m) ? 'Editar mi voto' : 'Emitir mi voto'"
            [icon]="myVote(m) ? 'fa-solid fa-pen' : 'fa-solid fa-check-to-slot'"
            class="p-button-success act-vote"
            (click)="openVote()"
          ></button>
          <ng-container *ngIf="!isSessionMeeting(m)">
            <button
              *ngIf="canEditVoters"
              pButton
              type="button"
              label="Editar votantes"
              icon="fa-solid fa-user-pen"
              class="p-button-outlined p-button-sm act-voters"
              (click)="openVoters()"
            ></button>
            <button
              *ngIf="canClose"
              pButton
              type="button"
              label="Cerrar reunión"
              icon="fa-solid fa-flag-checkered"
              class="p-button-outlined p-button-sm act-close"
              [disabled]="!quorum(m).met"
              [pTooltip]="!quorum(m).met ? 'Falta quórum para cerrar' : ''"
              (click)="openClose()"
            ></button>
          </ng-container>
        </div>
        <p class="quorum-warning" *ngIf="canClose && !isSessionMeeting(m) && !quorum(m).met">
          <i class="pi pi-exclamation-triangle"></i> Aún no se alcanza el quórum mínimo para cerrar la reunión.
        </p>
      </div>
    </div>

    <!-- Estado inicial: sin reuniones -->
    <div *ngIf="!hasOpenMeeting && closedMeetings.length === 0" class="info-card">
      <div class="card-content empty-state">
        <i class="pi pi-users"></i>
        <p *ngIf="canManage">El comité aún no ha sesionado sobre este arrendamiento. Llévalo a una sesión con «Llevar a comité».</p>
        <p *ngIf="!canManage">El comité aún no ha sesionado sobre este arrendamiento. En espera de que Legal lo lleve a una sesión.</p>
      </div>
    </div>

    <!-- Historial -->
    <div *ngIf="closedMeetings.length > 0" class="info-card wide-card">
      <div class="card-header">
        <i class="pi pi-history text-purple-600"></i>
        <h3>Historial de reuniones</h3>
      </div>
      <div class="card-content">
        <div class="history-item" *ngFor="let m of closedMeetings">
          <div class="history-head">
            <div class="hh-left">
              <p-tag [value]="resultLabel(m.meetingStatus)" [severity]="resultSeverity(m.meetingStatus)"></p-tag>
              <span class="hh-date"><i class="pi pi-calendar"></i> {{ formatDate(m.meetingDate) }}</span>
            </div>
            <p-tag
              *ngIf="minutesOf(m).length"
              [value]="minutesOf(m).length + (minutesOf(m).length === 1 ? ' acta' : ' actas')"
              severity="info"
              icon="fa-regular fa-file-lines"
            ></p-tag>
          </div>

          <ng-container *ngTemplateOutlet="sessionBlock; context: { $implicit: m }"></ng-container>

          <div class="voters-list history-voters">
            <div class="voter-row" *ngFor="let vt of m.participants">
              <div class="voter-main">
                <div class="voter-id">
                  <span class="avatar">{{ participantInitials(vt) }}</span>
                  <div class="voter-text">
                    <span class="voter-name">{{ participantName(vt) }}</span>
                    <span class="voter-email">{{ participantEmail(vt) }}</span>
                  </div>
                </div>
                <div class="voter-vote">
                  <p-tag
                    [value]="vt.decision"
                    [severity]="decisionSeverity(vt.decision)"
                    [icon]="vt.decision === 'Aprobado' ? 'pi pi-check' : 'pi pi-times'"
                  ></p-tag>
                </div>
              </div>
              <div class="voter-comment" *ngIf="vt.memberComments">
                <i class="pi pi-comment"></i>
                <p>{{ vt.memberComments }}</p>
              </div>
            </div>
          </div>

          <div class="history-note" *ngIf="m.generalComments">
            <i class="pi pi-align-left"></i>
            <p>{{ m.generalComments }}</p>
          </div>

          <!-- Actas de una reunión ya cerrada: se siguen pudiendo agregar y quitar (si no tiene sesión) -->
          <ng-container *ngTemplateOutlet="actasBlock; context: { $implicit: m }"></ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- MODAL: Emitir/editar voto (Admin) -->
  <p-dialog
    [header]="voteEditing ? 'Editar mi voto' : 'Emitir mi voto'"
    [(visible)]="showVoteModal"
    [modal]="true"
    [closable]="!submitting"
    styleClass="committee-meeting-modal"
    [style]="{ width: '460px' }"
  >
    <form [formGroup]="voteForm" class="form-stack">
      <div class="field field-flex">
        <label>*Mi decisión:</label>
        <div class="decision-choices">
          <button
            type="button"
            class="choice approve"
            [class.active]="voteForm.get('decision')?.value === 'Aprobado'"
            (click)="voteForm.get('decision')?.setValue('Aprobado')"
          >
            <i class="pi pi-thumbs-up"></i> Aprobar
          </button>
          <button
            type="button"
            class="choice reject"
            [class.active]="voteForm.get('decision')?.value === 'Rechazado'"
            (click)="voteForm.get('decision')?.setValue('Rechazado')"
          >
            <i class="pi pi-thumbs-down"></i> Rechazar
          </button>
        </div>
        <small class="p-error" *ngIf="voteForm.get('decision')?.touched && voteForm.get('decision')?.invalid">Elige tu decisión.</small>
      </div>
      <div class="field field-flex">
        <label for="vComments">Comentarios (opcional):</label>
        <textarea pInputTextarea formControlName="memberComments" id="vComments" rows="3"></textarea>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="submitting" (click)="showVoteModal = false"></button>
      <button
        pButton
        type="button"
        [label]="voteEditing ? 'Guardar voto' : 'Emitir voto'"
        icon="fa-solid fa-check"
        class="p-button-success"
        [disabled]="submitting || voteForm.invalid"
        (click)="submitVote()"
      ></button>
    </ng-template>
  </p-dialog>

  <!-- MODAL: Editar votantes (Legal / Admin) — solo reuniones sin sesión -->
  <p-dialog
    header="Editar votantes"
    [(visible)]="showVotersModal"
    [modal]="true"
    [closable]="!submitting"
    styleClass="committee-meeting-modal"
    [style]="{ width: '480px' }"
  >
    <form [formGroup]="votersForm" class="form-stack">
      <div class="field field-flex">
        <label for="evVoters">*Miembros votantes:</label>
        <p-multiSelect
          formControlName="selectedVoters"
          inputId="evVoters"
          [options]="memberOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecciona los miembros"
          selectedItemsLabel="{0} votantes"
          [maxSelectedLabels]="2"
          [filter]="true"
          appendTo="body"
          styleClass="w-full"
          emptyMessage="No hay miembros del comité elegibles"
          emptyFilterMessage="Ningún miembro coincide"
        ></p-multiSelect>
        <small class="hint">No puedes quitar a un miembro que ya emitió su voto.</small>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancelar"
        class="p-button-text"
        [disabled]="submitting"
        (click)="showVotersModal = false"
      ></button>
      <button
        pButton
        type="button"
        label="Guardar"
        icon="fa-solid fa-check"
        class="p-button-success"
        [disabled]="submitting || votersForm.invalid"
        (click)="submitVoters()"
      ></button>
    </ng-template>
  </p-dialog>

  <!-- MODAL: Cerrar reunión (Legal) — solo reuniones sin sesión -->
  <p-dialog
    header="Cerrar reunión"
    [(visible)]="showCloseModal"
    [modal]="true"
    [closable]="!submitting"
    styleClass="committee-meeting-modal"
    [style]="{ width: '520px' }"
  >
    <div class="close-summary" *ngIf="openMeeting as m">
      <div class="cs-row">
        <span>Resultado por mayoría</span
        ><p-tag [value]="resultLabel(projectedResult(m))" [severity]="resultSeverity(projectedResult(m))"></p-tag>
      </div>
      <div class="cs-row">
        <span>Quórum</span
        ><strong [class.met]="quorum(m).met">{{ quorum(m).voted }}/{{ quorum(m).selected }} (mín {{ quorum(m).min }})</strong>
      </div>
      <p class="cs-note" *ngIf="projectedIsTerminal(m)">
        <i class="pi pi-info-circle"></i> El acta no hace falta para cerrar: se agrega desde la sección Actas, antes o después.
      </p>
      <p class="cs-note tie" *ngIf="!projectedIsTerminal(m)">
        <i class="pi pi-info-circle"></i> Sin mayoría: la reunión quedará "En revisión" (no decide el arrendamiento).
      </p>
    </div>
    <form [formGroup]="closeForm" class="form-stack">
      <div class="field field-flex">
        <label for="cComments">Comentarios de cierre (opcional):</label>
        <textarea pInputTextarea formControlName="generalComments" id="cComments" rows="3"></textarea>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancelar"
        class="p-button-text"
        [disabled]="submitting"
        (click)="showCloseModal = false"
      ></button>
      <button
        pButton
        type="button"
        label="Cerrar reunión"
        icon="fa-solid fa-flag-checkered"
        class="p-button-success"
        [disabled]="submitting"
        (click)="submitClose()"
      ></button>
    </ng-template>
  </p-dialog>

  <!--
    Bloque de sesión (F-143) — la reunión pertenece a una sesión de N arrendamientos. Ahí se cierra,
    se editan votantes y se sube el acta; aquí se enlaza.
  -->
  <ng-template #sessionBlock let-m>
    <a class="session-link" *ngIf="isSessionMeeting(m)" [routerLink]="['/comites/sesion', sessionId(m)]">
      <i class="fa-solid fa-gavel" aria-hidden="true"></i>
      <span class="session-link-text">{{ sessionLabel(m) }}</span>
      <span class="session-link-cta">Ver sesión <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
    </a>
  </ng-template>

  <!--
    Bloque de Actas — reutilizado por la reunión en curso y por cada reunión del historial.
    A propósito NO depende de `canClose`, del quórum, de que la reunión siga abierta ni del freeze
    del comité: las actas se redactan fuera de la plataforma y llegan cuando el comité ya decidió.
    Ver, previsualizar y descargar SIEMPRE; subir y quitar solo en una reunión sin sesión (D-5).
  -->
  <ng-template #actasBlock let-m>
    <div class="actas-block">
      <div class="actas-head">
        <span class="actas-title"><i class="fa-regular fa-file-lines"></i> Actas</span>
        <span class="actas-count" *ngIf="minutesOf(m).length">{{ minutesOf(m).length }}</span>
      </div>

      <div class="actas-list" *ngIf="minutesOf(m).length; else sinActas">
        <div class="acta-row" *ngFor="let a of minutesOf(m)">
          <i class="fa-regular fa-file-pdf acta-icon"></i>
          <div class="acta-text">
            <span class="acta-name">{{ a.name }}</span>
            <span class="acta-meta">
              <ng-container *ngIf="uploaderLabel(a.uploadedBy) as who">{{ who }} · </ng-container>{{ formatDate(a.uploadedAt) }}
            </span>
          </div>
          <button
            pButton
            type="button"
            icon="fa-solid fa-eye"
            class="p-button-text p-button-sm acta-preview"
            pTooltip="Previsualizar"
            tooltipPosition="top"
            [attr.aria-label]="'Previsualizar ' + a.name"
            (click)="previewActaOpen(a)"
          ></button>
          <button
            pButton
            type="button"
            icon="fa-solid fa-download"
            class="p-button-text p-button-sm acta-download"
            pTooltip="Descargar"
            tooltipPosition="top"
            [attr.aria-label]="'Descargar ' + a.name"
            (click)="downloadActa(a)"
          ></button>
          <button
            *ngIf="canUploadMinutes && !isSessionMeeting(m)"
            pButton
            type="button"
            icon="fa-solid fa-trash"
            class="p-button-text p-button-sm p-button-danger acta-remove"
            pTooltip="Quitar"
            tooltipPosition="top"
            [attr.aria-label]="'Quitar ' + a.name"
            [disabled]="submitting"
            (click)="confirmRemoveMinute(m, a)"
          ></button>
        </div>
      </div>

      <ng-template #sinActas>
        <div class="actas-empty">
          <i class="fa-regular fa-file-lines"></i>
          <p>Aún no hay actas de esta reunión.</p>
          <small *ngIf="canUploadMinutes && !isSessionMeeting(m)"
            >Puedes subirlas cuando las tengas firmadas, aunque la reunión ya esté cerrada.</small
          >
          <small *ngIf="canUploadMinutes && isSessionMeeting(m)"
            >El acta se sube en la sesión y queda ligada a todos sus arrendamientos.</small
          >
        </div>
      </ng-template>

      <div class="actas-upload" *ngIf="canUploadMinutes && !isSessionMeeting(m)">
        <!--
          Se destruye y se vuelve a crear al registrar el acta: es la única forma de dejar el
          selector limpio para la siguiente, porque `app-input-single-file` solo resetea su estado
          interno cuando cambia `fileUrlValue`, y aquí siempre vale null.
        -->
        <app-input-single-file
          *ngIf="!isUploadingFor(m); else registrandoActa"
          label="Agregar acta"
          [folder]="'committee'"
          [documentName]="'acta-comite'"
          [id]="committee?._id || ''"
          [fileUrlValue]="null"
          [disabled]="submitting"
          [tooltip]="'Archivo PDF con el acta de la reunión'"
          (fileUrl)="onMinuteSelected(m, $event)"
        ></app-input-single-file>
        <ng-template #registrandoActa>
          <p class="actas-saving"><i class="pi pi-spin pi-spinner"></i> Registrando el acta…</p>
        </ng-template>
      </div>
    </div>
  </ng-template>

  <p-confirmDialog
    icon="pi pi-exclamation-triangle"
    acceptLabel="Sí, quitar"
    rejectLabel="Cancelar"
    acceptButtonStyleClass="p-button-danger"
  ></p-confirmDialog>
  <p-toast position="top-right"></p-toast>

  <!-- Visor del acta (F-011). El mismo componente compartido que usa el expediente del cliente. -->
  <app-file-preview-dialog
    [(visible)]="previewVisible"
    [fileUrl]="previewUrl"
    [fileName]="previewName"
    (downloadRequested)="downloadPreview()"
  ></app-file-preview-dialog>
</div>
